import { render, staticRenderFns } from "./AuthErrorLayer.vue?vue&type=template&id=ad96a67c&scoped=true"
import script from "./AuthErrorLayer.vue?vue&type=script&lang=js"
export * from "./AuthErrorLayer.vue?vue&type=script&lang=js"
import style0 from "./AuthErrorLayer.vue?vue&type=style&index=0&id=ad96a67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad96a67c",
  null
  
)

export default component.exports